import styled from '@emotion/styled';

export const Button = styled.button`
  ${({ theme }) => theme.typography.SEMI_BOLD_24};
  width: 350px;
  height: 80px;
  font-size: 24px;
  font-weight: 700;
  border-radius: 12px;
  color: ${({ theme }) => theme.color[5]};
  background-color: ${({ theme }) => theme.color[3]};
  box-shadow: 0px 4px 4px 0px #00000040;

  &:disabled {
    color: ${({ theme }) => theme.color[6]};
  }
`;
